export enum ReviewMode {
  Review,
  Correct,
}
